import confetti from 'canvas-confetti';
import { random } from 'lodash';
import React from 'react';

class Confetti extends React.Component {
  constructor(props) {
    super(props);
    this.confettiTimeouts = [];
    this.confettiCanvas = React.createRef();
    this.confettiInstance = null;
    this.audio = null;
  }

  componentDidMount() {
    if (this.confettiCanvas.current) {
      this.confettiInstance = confetti.create(this.confettiCanvas.current, {
        resize: true,
        useWorker: true
      });
      this.launchConfetti(this.props.animationType || 4);
    }
  }

  componentWillUnmount() {
    this.confettiTimeouts.forEach(clearTimeout);

    if (this.confettiInstance) {
      this.confettiInstance.reset();
    }

    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
  }

  stopAudio() {
    this.audio.pause();
    this.audio.currentTime = 0;
  }

  playAudio(audio) {
    this.audio = new Audio(`sounds/${audio}`);
    this.audio.volume = 0.4;
    this.audio.play();
  }

  // 1: central cannon from bottom
  // 2: central star explosion
  // 3: two side cannons from bottom
  // 4: cascade effect (gentle)
  // 5: final rain (intense cascade)
  // 6: fireworks (multiple explosions)
  // 7: school pride (continuous side bursts)
  launchConfetti(type) {
    this.confettiTimeouts.forEach(clearTimeout);
    this.confettiTimeouts = [];
    const colors = ['#ff6384', '#36a2eb', '#ffce56', '#4bc0c0', '#9966ff', '#ff9f40'];
    if (!this.confettiInstance) return;
    switch (type) {
      case 1: // central cannon from bottom
        this.confettiTimeouts.push(
          setTimeout(() => {
            this.confettiInstance({
              particleCount: 300,
              angle: 90,
              spread: 60,
              origin: { x: 0.5, y: 1 },
              colors
            });
            this.playAudio('confetti.wav');
          }, 100)
        );
        break;
      case 2: {
        // central star explosion
        const defaults = {
          spread: 360,
          ticks: 80,
          gravity: 0,
          decay: 0.96,
          startVelocity: 15,
          colors: ['FFE400', 'FFBD00', 'E89400', 'FFCA6C', 'FDFFB8']
        };
        this.playAudio('confetti.wav');
        // cannone centrale dall'alto verso il basso
        this.confettiTimeouts.push(
          setTimeout(() => {
            this.confettiInstance({
              ...defaults,
              particleCount: 50,
              scalar: 1.2,
              shapes: ['star']
            });
            this.playAudio('confetti.wav');
          }, 100),
          setTimeout(() => {
            this.confettiInstance({
              ...defaults,
              particleCount: 50,
              scalar: 1.2,
              shapes: ['star']
            });
            this.playAudio('confetti.wav');
          }, 300),
          setTimeout(() => {
            this.confettiInstance({
              ...defaults,
              particleCount: 50,
              scalar: 1,
              shapes: ['circle']
            });
          }, 100),
          setTimeout(() => {
            this.confettiInstance({
              ...defaults,
              particleCount: 50,
              scalar: 0.75,
              shapes: ['circle']
            });
          }, 100)
        );
        break;
      }
      case 3: // two side cannons from bottom
        this.confettiTimeouts.push(
          setTimeout(() => {
            this.confettiInstance({
              particleCount: 60,
              angle: 60,
              spread: 55,
              origin: { x: 0, y: 1 },
              colors
            });
            this.confettiInstance({
              particleCount: 60,
              angle: 120,
              spread: 55,
              origin: { x: 1, y: 1 },
              colors
            });
          }, 100)
        );
        break;
      case 4: // cascade effect (gentle)
        // Small, slow, sparse confetti, long duration
        for (let i = 0; i < 800; i++) {
          this.confettiTimeouts.push(
            setTimeout(() => {
              this.confettiInstance({
                particleCount: 1,
                startVelocity: 0,
                origin: {
                  x: Math.random(),
                  // since particles fall down, skew start toward the top
                  y: 0
                },
                gravity: random(0.3, 0.5),
                scalar: random(0.6, 1.2),
                drift: random(-0.3, 0.3),
                ticks: 500,
                colors
              });
            }, 100 + i * 100)
          );
        }
        break;
      case 5: // final rain - intense cascade effect
        this.playAudio('clapping.mp3');
        // Confetti falling gradually with stronger gravity
        for (let i = 0; i < 500; i++) {
          this.confettiTimeouts.push(
            setTimeout(() => {
              this.confettiInstance({
                particleCount: 1,
                startVelocity: 0,
                origin: {
                  x: Math.random(),
                  y: 0
                },
                gravity: random(0.7, 1.0), // maggiore gravità
                scalar: random(0.8, 1.4),
                drift: random(-0.5, 0.5),
                ticks: 800, // durata maggiore per raggiungere il fondo
                colors
              });
            }, 50 + i * 30) // cascata più densa
          );
        }
        break;
      case 6: // fireworks - multiple concentrated explosions
        this.playAudio('fireworks3.mp3');
        setTimeout(() => {
          this.stopAudio();
        }, 8000);
        this.confettiTimeouts.push(
          setTimeout(() => {
            this.confettiInstance({
              particleCount: 80,
              angle: 90,
              spread: 120,
              startVelocity: 40,
              origin: { x: 0.5, y: 0.4 },
              colors
            });
          }, 100),
          setTimeout(() => {
            this.confettiInstance({
              particleCount: 60,
              angle: 45,
              spread: 100,
              startVelocity: 35,
              origin: { x: 0.3, y: 0.3 },
              colors
            });
          }, 600),
          setTimeout(() => {
            this.confettiInstance({
              particleCount: 60,
              angle: 135,
              spread: 100,
              startVelocity: 35,
              origin: { x: 0.7, y: 0.3 },
              colors
            });
          }, 1200),
          setTimeout(() => {
            this.confettiInstance({
              particleCount: 100,
              angle: 90,
              spread: 150,
              startVelocity: 50,
              origin: { x: 0.5, y: 0.5 },
              colors,
              scalar: 1.2
            });
          }, 1800),
          setTimeout(() => {
            this.confettiInstance({
              particleCount: 70,
              angle: 60,
              spread: 110,
              startVelocity: 38,
              origin: { x: 0.2, y: 0.6 },
              colors
            });
          }, 2200),
          setTimeout(() => {
            this.confettiInstance({
              particleCount: 70,
              angle: 120,
              spread: 110,
              startVelocity: 38,
              origin: { x: 0.8, y: 0.6 },
              colors
            });
          }, 2600),
          setTimeout(() => {
            this.confettiInstance({
              particleCount: 80,
              angle: 90,
              spread: 130,
              startVelocity: 45,
              origin: { x: 0.5, y: 0.2 },
              colors
            });
          }, 3000)
        );
        break;
      case 7: // school pride - continuous side bursts
        const schoolColors = ['#bb0000', '#ffffff'];
        const endTime = Date.now() + 1 * 1500;

        const frame = () => {
          if (Date.now() < endTime) {
            // Burst from left
            this.confettiInstance({
              particleCount: 2,
              angle: 60,
              spread: 35,
              origin: { x: 0, y: 1 },
              colors: schoolColors
            });

            // Burst from right
            this.confettiInstance({
              particleCount: 2,
              angle: 120,
              spread: 35,
              origin: { x: 1, y: 1 },
              colors: schoolColors
            });

            // Continue next frame
            requestAnimationFrame(frame);
          }
        };

        // Start animation
        frame();
        this.playAudio('firework2.mp3');
        setTimeout(() => {
          this.playAudio('firework2.mp3');
        }, 1000);

        break;
      default:
        break;
    }
  }

  render() {
    return (
      <canvas
        ref={this.confettiCanvas}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 10
        }}
        width={600}
        height={300}
      />
    );
  }
}

export default Confetti;
